<template>
  <div id="mainContent">
    <TabsGroup @open-tab="loadComponent" />
    <div class="xpage-content">
      <ComponentFactory :identifier="tab" />
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted, onUnmounted } from "vue";
import TabsGroup from "@/components/v2/tabs/TabsGroup.vue";
import ComponentFactory from "@/components/factory/ComponentFactory.vue";
import { useApplicationStore } from "@/store/store/applicationVMStore";
import { useRoute, useRouter } from "vue-router";

const route = useRoute();
const router = useRouter();

const applicationStore = useApplicationStore();
const tab = ref("");

const loadComponent = (event) => {
  tab.value = `${event}${applicationStore.pageIdentifier}`;
  replaceQuery("CurrentTab", event);

  applicationStore.tabs.forEach(t => {
    t.isTabActive = false;
    if (`${event}` === t.identifier)
      t.isTabActive = true; 
  });
};

function replaceQuery(newQueryKey, newQueryValue) {
  const currentRoute = route.name || undefined;

  router.replace({
    name: currentRoute, // Or path: '/your-path'
    query: {
      ...route.query, // Keep existing query parameters
      [newQueryKey]: newQueryValue, // Add or update your specific parameter
    },
  });
}

function setCurrentTab() {
  const currentTab = route.query["CurrentTab"];

  if (currentTab) {
    loadComponent(currentTab);
  } else {
    const defaultTab = "ApplicationTab";

    const tabIdentifier = localStorage.getItem(
      `${applicationStore.pageIdentifier}.currentTab`
    );

    const tabExists = applicationStore.applicationTabs.some(
      (tab) => tab.identifier == tabIdentifier
    );

    applicationStore.updateActiveTab(tabExists ? tabIdentifier : defaultTab);

    tab.value = tabExists
      ? `${tabIdentifier}${applicationStore.pageIdentifier}`
      : `${defaultTab}${applicationStore.pageIdentifier}`;
  }
}
onMounted(() => {
  setCurrentTab();
});

onUnmounted(() => {
  localStorage.removeItem(`${applicationStore.pageIdentifier}.currentTab`);

  const currentQuery = { ...route.query };
  delete currentQuery["CurrentTab"];
  router.replace({ query: currentQuery });
});
</script>
